export const formatDeviationPrefix = (deviation: number) => {
  return deviation > 0 ? `+` : ``;
};

export const formatPercentage = (value: number): string => {
  return `${value}%`;
};

export const formatDeviation = (deviation: number) => {
  const prefix = formatDeviationPrefix(deviation);
  return `${prefix}${formatPercentage(deviation)}`;
};
